import { inject, Injectable } from '@angular/core';
import { of } from 'rxjs';
import { AppConfig } from '../../engine/app-config';
import { SettingsService } from '../../interface/settings-service';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService extends SettingsService {
  public readonly appConfig = inject(AppConfig);

  public override settings: any = {};

  public get settingName(): string {
    const id = this.appConfig.appId;
    let userName = '';
    if (localStorage.getItem('userContext')) {
      userName = localStorage.getItem('userContext')['user'];
    }
    return `${id}-${userName}-settings`;
  }

  public load() {
    const params = localStorage.getItem(this.settingName);
    if (params) {
      this.settings = JSON.parse(params);
      this.obs.next(true);
      return of(true);
    }
    this.obs.next(false);
    return of(false);
  }
  public addSetting(name: string, value: any) {
    this.settings[name] = value;
    this.save();
  }

  public getSetting(name: string) {
    if (this.settings) {
      return this.settings[name];
    } else {
      return undefined;
    }
  }

  public save() {
    localStorage.setItem(this.settingName, JSON.stringify(this.settings));
  }

  public clear() {
    localStorage.removeItem(this.settingName);
  }

  reset(): any {
    this.settings = {};
  }

  getSettingsKey(): string {
    return this.settingName;
  }

  getAuthorization(crud: string[]): boolean {
    void crud;
    return true;
  }
}
